module.exports = __webpack_public_path__ + "img/codepen-pick.f24ea349.png";